import { Routes } from '@angular/router';
import { canStartImpersonationGuard } from '@core/auth/can-start-impersonation.guard';
import { APP_ROUTES } from '@core/constants/routes.constants';

export const impersonationRoutes: Routes = [
  {
    title: 'pagesTitles.impersonation',
    path: APP_ROUTES.IMPERSONATION,
    canActivate: [canStartImpersonationGuard()],
    loadComponent: () => import('./pages/impersonate-user').then((m) => m.ImpersonateUserPage),
  },
];
